import { SxProps } from '@mui/material';

export const BenefitItemContentSX = (isTablet: boolean) =>
	({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: isTablet ? '0 15px' : '0',
		border: '1px solid #011688',
		borderRadius: '4px',
		width: '100%',
		height: isTablet ? '200px' : '140px',
		justifyContent: 'center',
	} as SxProps);

export const BenefitImgContainerSX: SxProps = {
	display: 'flex',
	justifyContent: 'center',
	marginBottom: '8px',
};

export const BenefitItemTitleSX = (isTablet: boolean) =>
	({
		fontWeight: '600',
		fontSize: isTablet ? 'var(--font-size-default)' : 'var(--font-size-body)',
		color: '#011688',
		textAlign: 'center',
		marginBottom: '7.32px',
	} as SxProps);

export const BenefitItemDescriptionSX: SxProps = {
	fontWeight: 'normal',
	fontSize: 'var(--font-size-small)',
	color: '#929292',
	textAlign: 'center',
};
